<template>
  <div class="modal-top-section modal-top-section--align-center" v-if="!fromDetailTemplate">
    <h3 class="modal-top-section__title">Datos generales de tu IVR</h3>
    <p class="modal-top-section__subtitle">Completa los campos requeridos</p>
  </div>

  <a-form ref="form" layout="vertical" :model="formState" class="ivr-step-one-form">
    <a-form-item label="Nombre de IVR" name="name" required>
      <a-input
        v-model:value="formState.name"
        placeholder="Escribir nombre de IVR"
        :disabled="disabled"
      />
    </a-form-item>

    <a-form-item label="Descripción del IVR" name="description">
      <a-textarea
        :disabled="disabled"
        v-model:value="formState.description"
        placeholder="Escribe aquí..."
        showCount
        :maxlength="100"
      />
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { reactive, ref, watch } from "vue";
// import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { isEqual, cloneDeep } from "lodash";

import { DetailsForm } from "@/@types/ivr/forms";
// import { BotType } from "@/app/ivr/bot/utils/enums";
import { Bot } from "@/@types/ivr";

const props = defineProps<{
  fromDetailTemplate?: boolean;
  botDetails?: Bot;
  disabled?: boolean;
  isAutomatic?: boolean;
}>();

const emit = defineEmits<{
  (e: "toggle-activate-button", isDisabled: boolean): void;
}>();

const form = ref();

const formState = reactive<DetailsForm>({
  name: props.botDetails?.name || "",
  description: props.botDetails?.description || "",
  portfolio: undefined,
  type: props.botDetails?.type,
});

formState.submitForm = async () => {
  try {
    if (form.value) await form.value.validate();
    return [true];
  } catch (error) {
    console.log("error", error);
    return [false];
  }
};

const comparisonForm = cloneDeep(formState);

watch(formState, () => {
  const isDisabled = isEqual(formState, comparisonForm) || !formState.name;

  emit("toggle-activate-button", isDisabled);
});

defineExpose({ formState });
</script>

<style scoped lang="sass">
h3
  color: $gray-9
  font-size: 20px
  margin-bottom: 16px

.ivr-step-one-form
  :deep(textarea)
    max-height: 220px
</style>
